import Footer from '~/components/Footer/FooterGql'

import { compose } from 'ramda'

import withLayout from '~/hoc/withLayout'
import { withNamespaces } from '>/i18n'

const KlarnaHelp = ({ t }) => {
  return (
    <>
      <klarna-placement
        class='klarna-placement'
        data-key='info-page'
        data-locale='pl-PL'
      />
      <Footer />
    </>
  )
}

export default compose(
  withLayout({
    namespaces: ['klarna-help'],
  }),
  withNamespaces('klarna-help')
)(KlarnaHelp)
